var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 12.5L8.33333 10",
    stroke: "#DA0000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.5L11.6667 10",
    stroke: "#DA0000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83301H17.5V5.83301C17.0353 5.83301 16.803 5.83301 16.6098 5.87144C15.8164 6.02925 15.1962 6.64945 15.0384 7.44283C15 7.63603 15 7.86835 15 8.33301V12.6663C15 14.552 15 15.4948 14.4142 16.0806C13.8284 16.6663 12.8856 16.6663 11 16.6663H9C7.11438 16.6663 6.17157 16.6663 5.58579 16.0806C5 15.4948 5 14.552 5 12.6663V8.33301C5 7.86835 5 7.63603 4.96157 7.44283C4.80376 6.64945 4.18356 6.02925 3.39018 5.87144C3.19698 5.83301 2.96466 5.83301 2.5 5.83301V5.83301Z",
    stroke: "#DA0000",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39012 2.80883C8.48508 2.72023 8.69432 2.64194 8.9854 2.5861C9.27647 2.53027 9.63311 2.5 10 2.5C10.3669 2.5 10.7235 2.53027 11.0146 2.5861C11.3057 2.64194 11.5149 2.72023 11.6099 2.80883",
    stroke: "#DA0000",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.0beefc96cd340f96d000ec2a005b3aa4.svg";
export { ForwardRef as ReactComponent };